export const VERSION = "test";